module.exports = __webpack_public_path__ + "img/site_logo.b428593c.svg";